export default __webpack_public_path__ + "static/media/eight.e491c267.png";